// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StaticLayout_wrapper_1UkTm","logo":"StaticLayout_logo_3zTWX","title":"StaticLayout_title_1omfv"};